/* global nativeSucceedShare */
/* global nativeFailedCallback */
/* global nativeCanceledCallback */
/* global GLOBAL_LOGGER */
import React, { Component } from 'react';
import { ListView, Toast } from 'antd-mobile';
import http from '../util/http';
import tools from '../util/tools';
import Native from '../util/native';
import './App.scss';
import notePic from './images/no-info.png';
import seePic from './images/see.png';
import videoBg from './images/videobg.jpg';
import headIcon from "./images/headicon.jpg";

const GET = tools.getQuery(window.location.href);

class App extends Component {
  constructor(props) {
    super(props);

    const getRowData = (dataBlob, sectionID, rowID) => dataBlob[rowID];

    const dataSource = new ListView.DataSource({
      getRowData,
      rowHasChanged: (row1, row2) => true,
    });

    let userInfo = {
      userId: GET.userId || "",
      nickName: '匿名用户',
      avatar: '暂无头像'
    };

    if (Native.isInNative()) {
      userInfo = Native.getUserInfo();
      userInfo.avatar = "暂无头像";
    }

    this.state = {
      userId: userInfo.userId, //用户id
      name: userInfo.nickName,   //用户名称
      avatar: userInfo.avatar,
      inputValue: '',
      isShow: false,
      isFocus: false,
      isHeight: document.body.clientHeight,
      detailList: {},
      author: {},
      readList: [],
      commentList: [],
      dataSource,
      isLoading: true,
      hasMore: true,
      listViewUpdate: 0,
      searchStart: 0,
      searchCount: 10,
      count: 0,
      logParams: {

      }
    }
  }

  async componentDidMount() {

    Toast.loading('加载中...');

    const response = await http.get('?r=news/info', {
      id: GET.newsID,
      plat: GET.plat,
      userId: this.state.userId,
      name: this.state.name,
      avatar: this.state.avatar,
    });
    Toast.hide();
    if (response.code !== 0) {
      Toast.fail(response.msg);
      return;
    }

    let wxShareOptions = {
      shareData: {
        title: response.info.newInfo.news.title,
        desc: response.info.newInfo.news.desc
      }
    };
    tools.setWechatShare(wxShareOptions);

    const response2 = await http.get('?r=news/comment-list', {
      newsId: GET.newsID,
      plat: GET.plat,
      userId: this.state.userId,
      start: this.state.searchStart,
      limit: this.state.searchCount
    });

    let list;
    if (response2.code === 0) {
      list = response2.info.list
    } else {
      Toast.fail(response2.msg);
      return;
    }
    this.setWebViewTitle(response.info.newInfo.news.title);
    this.setState({
      detailList: response.info.newInfo.news,
      author: response.info.newInfo.author,
      // newsId: response.info.newInfo.news.id,
      isLoading: false,
      isLike: response.info.newInfo.is_liked, //对详情页文章点赞
      // newsId: id,
      count: response2.info.total,
      commentList: list || [],
      readList: response.info.newInfo.recommendNews || [],
      dataSource: this.state.dataSource.cloneWithRows(list),
      logParams: {
        id: response.info.newInfo.news.id,
        title: response.info.newInfo.news.title,
        category_id: response.info.newInfo.news.category_id,
        type: response.info.newInfo.news.type
      }
    })

    GLOBAL_LOGGER.init({
      ep: this.state.logParams
    });
    // this.setState({
    //   slides: response.data.banners,
    //   columnList: response.data.recommendedColumns
    // });

    this.bindVideoPlay();
    tools.fixVideoDragBug();
  }
  setWebViewTitle = (title) => {
    document.getElementsByTagName('title')[0].innerHTML = title;
  }
  //分享
  setShareContent = async () => {
    if (this.state.userId === "") {
      Toast.info('请先登录后再分享');
      return;
    }
    Native.setShareContent({
      title: this.state.detailList.title,
      content: this.state.detailList.desc,
      url: window.location.href
    });
    nativeSucceedShare = async () => {
      const response = tools.logNews(GET.newsID, this.state.userId, 1);
    }
  }
  onEndReached = async (event) => {
    // load new data
    // hasMore: from backend data, indicates whether it is the last page, here is false
    if (this.state.isLoading || !this.state.hasMore) {
      return;
    }

    this.setState({
      isLoading: true,
      searchStart: this.state.searchStart + this.state.searchCount
    });

    const response = await this.getCommentList(GET.plat, this.state.searchStart, this.state.searchCount);

    if (response.code !== 0) {
      Toast.fail(response.msg);
      return;
    }
    if (response.info && response.info.list.length > 0) {
      let currentList = this.state.commentList;
      currentList = currentList.concat(response.info.list);
      this.setState({
        commentList: currentList,
        dataSource: this.state.dataSource.cloneWithRows(currentList),
        commentTotal: response.info.total,
        isLoading: false,
      })
    } else {
      this.setState({
        hasMore: false,
        isLoading: false
      })
    }

  }

  // 获取input框value值
  getInputValue = (e) => {
    this.setState({
      inputValue: e.target.value,
    })
  }

  commitComment = async (content) => {
    const response = await http.post('?r=news/comment', {
      newsId: GET.newsID,
      userId: this.state.userId,
      type: 1,
      name: this.state.name,
      // avatar: this.state.avatar,
      content: content
    });
    GLOBAL_LOGGER.log({
      eventTypeName: 'click',
      en: 'comment',
      ep: {
        ...this.state.logParams,
        newsId: GET.newsID,
        userId: this.state.userId,
        name: this.state.name,
        // avatar: this.state.avatar,
        content: content
      }
    });
    return response;
  }

  getCommentList = async (plat = "", start = 0, limit = 10) => {
    const response = await http.get('?r=news/comment-list', {
      newsId: GET.newsID,
      plat: plat,
      userId: this.state.userId,
      start: start,
      limit: limit
    });
    return response;
  }

  // 回车事件
  handleKeyDown = async (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      if (this.state.inputValue.trim() === "") {
        Toast.info('请输入评论', 2);
        return;
      }

      const commentResponse = await this.commitComment(this.state.inputValue);
      if (commentResponse.code === 0) {
        this.setState({
          searchStart: 0,
          searchCount: 10,
          inputValue: ""
        });
        Toast.success("评论成功！", 2);
        this.hidePopup();

        const commentListResponse = await this.getCommentList(GET.plat, this.state.searchStart, 1);
        if (commentListResponse.code === 0) {
          const list = commentListResponse.info.list;
          const commentList = [].concat(list).concat(this.state.commentList);

          this.setState({
            // listViewUpdate: this.state.listViewUpdate + 1,
            commentList: commentList,
            count: commentListResponse.info.total,
            dataSource: this.state.dataSource.cloneWithRows(commentList),
            isShow: false,
          }, () => { });
        } else {
          console.error(commentListResponse);
        }
      } else {
        console.error(commentResponse);
      }
    }
  }


  // 评论列表中的点赞
  // commentResponse = async(cid,) =>{
  //   let response = await http.post('?r=news/like',{
  //     cid:cid,
  //     uid:this.state.userId,
  //     plat:1,
  //     status: 1,
  //     nid:GET.newsID,
  //   });
  //   return response;
  // } 

  commitNewsLike = async (cid, status) => {
    const response = await http.post('?r=news/like', {
      cid: cid,
      uid: this.state.userId,
      plat: GET.plat || 1,
      status: status,  //取消点赞
      nid: GET.newsID,
    });
    GLOBAL_LOGGER.log({
      eventTypeName: 'click',
      en: 'commment_like',
      ep: {
        cid: cid,
        uid: this.state.userId,
        plat: GET.plat || 1,
        status: status,  //取消点赞
        nid: GET.newsID,
        ...this.state.logParams
      }
    });
    return response;
  }
  commentLike = async (cid, index) => {

    if (this.state.userId === "") {
      Toast.info('请先登录后再点赞', 1);
      return;
    }

    let num = index;
    let commentList = this.state.commentList;
    let status = 0;
    let likeNum = Number(commentList[num].liked_num);
    let isDoLike = commentList[num].lid > 0 ? false : true; // 点赞

    if (isDoLike) {
      status = 1;
    }
    const response = await this.commitNewsLike(cid, status);
    if (response.code === 0) {
      if (isDoLike) {
        commentList[num].lid = num + 1;
        commentList[num].liked_num = likeNum + 1;
        Toast.success("点赞成功", 1);
      } else {
        commentList[num].lid = 0;
        commentList[num].liked_num = likeNum - 1;
        Toast.info("取消点赞成功", 1);
      }
      this.setState({
        // listViewUpdate: this.state.listViewUpdate + 1,
        commentList: commentList,
        dataSource: this.state.dataSource.cloneWithRows(commentList),
      });
    } else {
      Toast.fail(response.msg);
    }

  }

  //显示评论弹窗
  showPopup = (e) => {
    if (this.state.userId === "") {
      Toast.info('请先登录后再点赞');
      return;
    }
    this.setState({
      isShow: true
    }, () => {
      if (this.input) {
        this.input.focus();
      }
    })
  }

  onInputFocus = (e) => {
    // this.showPopup();
    tools.fixKeyboardCover();
    this.setState({
      isFocus: true
    });
  }

  onInputBlur = (e) => {
    this.setState({
      isFocus: false
    })
  }

  //隐藏弹窗
  hidePopup = (e) => {
    e && e.preventDefault();
    this.setState({
      isShow: false
    }, () => {
      if (this.input) {
        this.input.blur()
      }
    })
  }

  //对详情页内容点赞或取消赞 
  isLikedContent = async (type) => {
    const response = await http.post('?r=news/comment', {
      newsId: GET.newsID,
      userId: this.state.userId,
      type: type,
      name: this.state.name,
      // avatar: this.state.avatar,
    });
    GLOBAL_LOGGER.log({
      eventTypeName: 'click',
      en: 'like',
      ep: {
        userId: this.state.userId,
        likeType: type,
        name: this.state.name,
        ...this.state.logParams,
      }
    });
    return response;
  }

  praiseEssays = async () => {
    let isliked = this.state.isLike;
    if (this.state.userId === "") {
      Toast.info('请先登录后再点赞');
      return;
    }
    if (isliked === false) {
      const response = await this.isLikedContent(2); //点赞
      if (response.code === 0) {
        Toast.success('点赞成功', 1);
        isliked = true;
      }
    } else {
      const response = await this.isLikedContent(3); //取消点赞
      if (response.code === 0) {
        Toast.info('取消点赞成功', 1);
        isliked = false;
      }
    }
    this.setState({
      isLike: isliked
    })
  }

  // getValue=(e)=>{
  //   this.setState({
  //     value: this.refs.text.innerHTML
  //   })
  //   console.log(this.state.value);
  // }

  bindVideoPlay = () => {
    const video = document.getElementById('video-player');
    let isLogged = false;
    let lastTime = 0;
    if (video) {
      video.addEventListener('play', () => {
        if (!isLogged) {
          tools.logNews(GET.newsID, this.state.userId, 2);
          isLogged = true;
          GLOBAL_LOGGER.log({
            eventTypeName: 'click',
            en: '视频播放点击',
            ep: {
              ...this.state.logParams,
            }
          });
          // tools.journal('play', `news_id=${id}&title=${title}&type=${type}&categoryId=${categoryId}`);
        }
      });
      video.addEventListener('timeupdate', () => {
        let currentTime = video.currentTime;
        let videoId = this.state.detailList.file_id;
        if (currentTime - lastTime >= 10) {
          GLOBAL_LOGGER.log({
            eventTypeName: 'loaddata',
            en: '视频播放更新',
            ep: {
              videoId: videoId,
              currentTime: currentTime,
              ...this.state.logParams,
            }
          });
          lastTime = currentTime;
        }

      });
    }
  }

  render() {
    let isVideo = this.state.detailList.type === 2 ? true : false;
    let videoHTML;
    if (isVideo) {
      videoHTML = (
        <div className="detail-video-box"
          data-id={this.state.detailList.id}
          data-title={this.state.detailList.title}
          data-type={this.state.detailList.type}
          data-categoryid={this.state.detailList.category_id}
        >
          <video
            id="video-player"
            preload="auto"
            controls
            controlsList="nodownload"
            playsInline
            poster={this.state.detailList.file_img_url ? this.state.detailList.file_img_url : videoBg}
            src={this.state.detailList.file_url.HD}>
          </video>
        </div>
      );
    }
    // 资讯详情展示
    let detailHTML;
    if (!!this.state.detailList) {
      detailHTML = (
        <div className="detail-box">
          <div className="detail-title">{this.state.detailList.title}</div>
          <div className="author-box">
            <div className="author-logo">
              {this.state.author.head_img_url ? <img src={this.state.author.head_img_url} alt="pic" /> : ""}
              {this.state.author.name}
            </div>
            <div className="author-time">{this.state.detailList.publish_at}</div>
          </div>
          {
            isVideo ?
              <div className="detail-content">{this.state.detailList.desc}</div> :
              <div className="detail-content" dangerouslySetInnerHTML={{ __html: this.state.detailList.content }}></div>
          }
        </div>
      )
    }

    //推荐阅读
    let readHTML;
    if (this.state.readList && this.state.readList.length > 0) {
      readHTML = (
        <div className="read-box">
          {this.state.readList.map((item, index) => (
            <a key={index} data-id={item.id} className="read-list" href={`newsDetail.html?newsID=${item.id}&plat=1`}>
              <div className="read-list-left">
                <div className="read-subtitle">{item.title}</div>
                <div className="read-note">
                  {item.author_name}
                  <img src={seePic} alt="pic" />
                  {item.view_num}热度
                </div>
              </div>
              {item.imagesList[0] ?
                <div className="read-list-right">
                  <img src={item.imagesList[0]} alt="pic" style={{ width: '100%', height: '75px' }} />
                </div>
                : ""}
            </a>
          ))}
        </div>
      )
    }

    // 评论列表
    const row = (rowData, sectionID, rows) => {
      const list = this.state.commentList[rows];
      return (
        <div className="comment-list">
          <div className="comment-icon">
            <img src={list.avatar ? list.avatar : headIcon} alt="icon" style={{ width: '100%', height: '38px', borderRadius: '50%' }} />
          </div>
          <div className={rows == "0" ? "comment-word comment-word-special" : "comment-word"}>
            <div className="commentator-info">
              <div className="commentator-nickname">{list.name}</div>
              <div className="commentator-data">
                <div
                  className={list.lid > 0 ? "commentator-like commentator-like-special" : "commentator-like"}
                  onClick={() => { this.commentLike(list.id, rows) }}
                ></div>
                <div className="commentator-number">{list.liked_num}</div>
              </div>
            </div>
            <div className="commentator-des">{list.content}</div>
            <div className="commentator-time">{list.created_at}</div>
          </div>
        </div>
      )
    }

    const resultList = (
      <div className="rank-list-container">
        {
          this.state.commentList.length > 0 ?
            <ListView
              key={this.state.listViewUpdate}
              className="rank-list"
              dataSource={this.state.dataSource}
              renderRow={row}
              onEndReached={this.onEndReached}
              scrollRenderAheadDistance={500}
              useBodyScroll={true}
              renderFooter={() => (<div style={{ textAlign: 'center' }}>
                {this.state.isLoading ? '加载中...' : ''}
              </div>)}
              onEndReachedThreshold={10}
              style={{
                overflow: 'auto'
              }}
            /> :
            <div style={{ textAlign: 'center', color: '#C8C8C8', fontSize: '12px', }}>
              {this.state.isLoading ?
                (
                  <div style={{ padding: '5px 0' }}>加载中......</div>
                )
                :
                (
                  <div>
                    <img src={notePic} alt="pic" style={{ width: '180px', height: '60px', margin: '0px auto 20px' }} />
                    暂时还没有评论
                  </div>
                )
              }
            </div>
        }
      </div>
    );

    // 底部评论点赞区
    let footHTML;
    // footHTML = (
    //   <div>
    //     {this.state.userId !== "" ?
    //       <div className="send-box">
    //         <div className="send-info">
    //           <form id="send-form" action="javascript:return true">
    //             <input
    //               type="text"
    //               placeholder="写评论…"
    //               className="send-input"
    //               value={this.state.inputValue}
    //               onChange={this.getInputValue}
    //               onKeyDown={this.handleKeyDown}
    //               onFocus={this.onInputFocus}
    //               onBlur={this.onInputBlur}
    //             />
    //           </form>
    //         </div>
    //         {/* <div className="icon-info">
    //       <div className="icon-info-num">1</div>
    //     </div>
    //     <div className="icon-collect"></div>
    //     <div className="icon-like"></div>
    //     <div className="icon-share"></div> */}
    //       </div>

    //       : ""}
    //   </div>
    // );
    footHTML = (
      <div>
        <div className="send-box">
          <div className="send-info" onClick={this.showPopup}>写评论…</div>
          <div className="icon-info">
            <a href="#comment-title">
              <div className="icon-info-num" style={{ display: (this.state.count > 0) ? "block" : "none" }}>{this.state.count}</div>
            </a>
          </div>
          <div className="icon-collect" style={{ display: 'none' }}></div>
          <div className={this.state.isLike ? "icon-like commentator-like-special" : "icon-like"} onClick={this.praiseEssays}></div>
          {/* <div className="icon-share" onClick={this.setShareContent}></div> */}
        </div>
      </div>
    );

    let popupHTML;
    popupHTML = (
      <div className="popup" style={{ display: (this.state.isShow) ? "block" : "none" }}>
        <div className="popup-outerbox" onClick={this.hidePopup} ></div>
        <div className="popup-container">
          <div className="popup-content">
            <form id="send-form" onSubmit={(e) => { e.preventDefault(); return true; }}>
              <input
                type="text"
                ref={refs => this.input = refs}
                placeholder="写评论…"
                className="send-input"
                value={this.state.inputValue}
                onChange={this.getInputValue}
                onKeyDown={this.handleKeyDown}
                onFocus={this.onInputFocus}
                onBlur={this.onInputBlur}
              />
              {/* <textarea
                  type="text"
                  contenteditable="true"
                  ref={refs => this.input = refs}
                  placeholder="写评论…"
                  className="send-input"
                  value={this.state.inputValue}
                  onChange={this.getInputValue}
                  onKeyDown={this.handleKeyDown}
                  onFocus={this.onInputFocus}
                  onBlur={this.onInputBlur}
                ></textarea> */}
            </form>
            {/* <div className="popup-icon"></div> */}
          </div>
        </div>
      </div>
    )



    return (
      <div className="app">
        <div className="app-content">
          <header className="app-header">
            {videoHTML && videoHTML}
          </header>
          <section>
            {detailHTML && detailHTML}
          </section>
          {/* <div className="line"></div> */}

          {false ?
            <section>
              <div className="read-title"><p>推荐阅读</p></div>
              {readHTML && readHTML}
            </section>
            : ""
          }

          {
            false && !GET.noComment ?
              <>
                <div className="line"></div>
                <section>
                  <div className="read-title" id="comment-title"><p>最新评论</p></div>
                  {resultList}
                  <div className={!this.state.isLoading && !this.state.hasMore ? "no-more" : "no-more-special"}>
                    ----没有更多内容----
                </div>
                </section>
              </>
              : ""
          }

        </div>
        {this.state.userId ?

          <div className="bottom">
            {footHTML}
          </div>
          : ""}
        {popupHTML}
        {/* {tab && tab} */}
      </div>
    );
  }
}

export default App;
